/**
 * Format helpers shared across job/pin renderers.
 * Kept small and pure so they're safe to import anywhere.
 */

/**
 * Strip a leading "Unit " (case-insensitive) from a stored unit value.
 * Some legacy AppFolio/Kraaft rows stored `unit = "Unit 2"` which then
 * became "Unit Unit 2" once the UI added its own "Unit" prefix.
 *
 * Also drops repeated "Unit Unit" if a bad backfill ran twice.
 */
export function formatUnit(u) {
  if (!u) return "";
  let s = String(u).trim();
  // Repeat until no more leading "Unit " (handles "Unit Unit 2")
  while (/^unit\s+/i.test(s)) s = s.replace(/^unit\s+/i, "");
  return s;
}

/**
 * Render "5922 Osage Ave · Unit 2" from address + unit.
 * Handles missing unit and the "Unit Unit" bug in one place.
 *
 * Also defensively strips trailing "Unit X" / "Unit Unit X" from the
 * address string itself when the unit field is empty — some AppFolio
 * imports stashed the unit info in the address column instead of the
 * dedicated `unit` field.
 */
export function formatAddressUnit(address, unit) {
  let addr = String(address || "").trim();
  let u = formatUnit(unit);

  // If unit is empty and the address ends in "Unit <something>", split it out.
  if (!u && addr) {
    const m = addr.match(/^(.*?)\s+(?:Unit\s+)+(\S+)\s*$/i);
    if (m) {
      addr = m[1].trim();
      u = m[2].trim();
    }
  }

  // If address itself has "Unit Unit X" duplication mid-string, collapse.
  addr = addr.replace(/\s+(?:Unit\s+){2,}(\S+)/i, " Unit $1");

  if (!addr) return u ? `Unit ${u}` : "";
  return u ? `${addr} · Unit ${u}` : addr;
}
